/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ResourcesActions, ResourcesActionTypes, ResourcesState } from './types';

export const setThumbnailsVersion = (thumbnailsVersion: ResourcesState['thumbnailsVersion']): ResourcesActionTypes => ({
  type: ResourcesActions.SET_THUMBNAILS_VERSION,
  payload: { thumbnailsVersion },
});
